import { httpClient } from '../httpClient';
import ErrorNormalizer, { ApiType } from '../ErrorNormalizer';

interface IWixWizSiteMediaPageSection {
  type: string;
  logo?: string;
}

interface IWixWizSiteMediaPage {
  images: string[];
  sections?: IWixWizSiteMediaPageSection[];
}

interface IWixWizSiteMedia {
  pages: IWixWizSiteMediaPage[];
}

interface IWixWizFacebookAlbumPhoto {
  photo_url: string;
}

interface IWixWizFacebookAlbum {
  name: string;
  photos: IWixWizFacebookAlbumPhoto[];
}

interface IWixWizFacebookGeneralInfo {
  logo?: string;
}

interface IWixWizFacebookPlatform {
  platform_name: string;
  general_info?: IWixWizFacebookGeneralInfo;
  photos_albums?: IWixWizFacebookAlbum[];
  videos_albums?: IWixWizFacebookAlbum[];
}

interface IWixWizFacebookMedia {
  platforms?: IWixWizFacebookPlatform[];
  error?: string;
}

// original url: http://wizard.wix.com/api/platformsearch
const WIX_WIZ_FACEBOOK_ENDPOINT = '/wizard/api/analyzeplatforms/';
// original url: https://bo.wix.com/_api/any2wix-website-analyzer-bo-web/analyzeSite?url=http://www.thesartorialist.com&noWrap=true
const WIX_WIZ_SITE_ENDPOINT =
  '/bo/_api/any2wix-website-analyzer-bo-web/analyzeSite';

const FACEBOOK_PLATFORM = 'facebook_onboarding';
const FACEBOOK_ALBUM_NAME = 'last photos';

const errorNormalizer = new ErrorNormalizer(ApiType.WIX_WIZ);

function getSiteMedia(url: string): Promise<IWixWizSiteMedia> {
  return httpClient
    .get<IWixWizSiteMedia | { errorMessage: string }>(WIX_WIZ_SITE_ENDPOINT, {
      // TODO use prod version
      params: {
        noWrap: true,
        url,
      },
    })
    .then((response) => {
      const data = response.data;
      if (data && 'errorMessage' in data) {
        throw new Error(data.errorMessage);
      }
      return data as IWixWizSiteMedia;
    })
    .catch((e) => {
      throw errorNormalizer.normalizeError(e);
    });
}

function getFacebookMedia(url: string): Promise<IWixWizFacebookMedia> {
  return httpClient
    .post<IWixWizFacebookMedia>(WIX_WIZ_FACEBOOK_ENDPOINT, {
      // TODO use prod version
      requestOrigin: 'onboarding',
      platrforms: ['facebook'],
      urls: [url],
    })
    .then((response) => response.data)
    .catch((e) => {
      throw errorNormalizer.normalizeError(e);
    });
}

export {
  getSiteMedia,
  getFacebookMedia,
  IWixWizSiteMediaPage,
  IWixWizSiteMedia,
  IWixWizFacebookAlbumPhoto,
  IWixWizFacebookAlbum,
  IWixWizFacebookPlatform,
  IWixWizFacebookMedia,
  WIX_WIZ_FACEBOOK_ENDPOINT,
  WIX_WIZ_SITE_ENDPOINT,
  FACEBOOK_PLATFORM,
  FACEBOOK_ALBUM_NAME,
};
